import React, { useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ArtStage from '../../../ArtStage';
import CentralColumn from '../CentralColumn';
import Details from '../../../DeviationViews/Details';
import Comments from '../Comments';
import TextualContent from '../../../DeviationViews/TextualContent/TextualContent';
import StashBanner from '../../../banners/StashBanner';
import ActionBar from '../../../ActionBar';
import s from './StashPageContent.scss';
const StashPageContent = ({ deviation })=>{
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['left-column'], s['stage'])
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), !isMobile && /*#__PURE__*/ React.createElement(StashBanner, {
        className: s['banner']
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Details, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['left-column'], s['meta'])
    }, /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(Comments, {
        deviation: deviation,
        className: s['comments']
    }))));
};
StashPageContent.displayName = 'StashPageContent';
export default StashPageContent;

//# sourceMappingURL=StashPageContent.js.map